import { useQuery } from "react-query";
import * as ajaxEndpoints from "../api/ajax-endpoints";
import { getDataWithDotNet } from "../newApis/dotNetApiMethods";

const getFailedPendingDisbursement = async () => {
  const { data } = await getDataWithDotNet(
    ajaxEndpoints.GET_FAILED_DISBURSEMENT
  );
  return data;
};

export default function useFailedPendingDisbursement() {
  return useQuery(
    ["getFailedPendingDisbursement"],
    getFailedPendingDisbursement,
    {
      refetchOnWindowFocus: false,
    }
  );
}
